var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_info-circle",
    "data-name": "vuesax/bold/info-circle",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.667,0a6.667,6.667,0,1,0,6.667,6.667A6.678,6.678,0,0,0,6.667,0Zm-.5,4a.5.5,0,0,1,1,0V7.333a.5.5,0,0,1-1,0ZM7.28,9.587a.688.688,0,0,1-.14.22.77.77,0,0,1-.22.14.628.628,0,0,1-.507,0,.77.77,0,0,1-.22-.14.688.688,0,0,1-.14-.22.628.628,0,0,1,0-.507.6.6,0,0,1,.36-.36.667.667,0,0,1,.507,0,.6.6,0,0,1,.36.36.628.628,0,0,1,0,.507Z",
    transform: "translate(1.333 1.333)",
    fill: "#030014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    transform: "translate(16 16) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.e9e2d6a50acc5085c5d731d72c06f0cf.svg";
export { ForwardRef as ReactComponent };